import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "card-title d-flex align-items-center seller-header" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-award" }, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("h2", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('seller-ranking-title')), 1)
    ]));
}
